/**
 * Responsive design breakpoints
 * Mobile: <= MOBILE_BREAKPOINT
 * Desktop: > MOBILE_BREAKPOINT
 */
export const MOBILE_BREAKPOINT = 992;

/**
 * Media query string for mobile detection
 */
export const MOBILE_MEDIA_QUERY = `(max-width: ${MOBILE_BREAKPOINT}px)`;

/**
 * Порог, ниже которого страницы Hub'а показывать нечестно (#322): таблицы,
 * дашборд и триаж под такую ширину не рассчитаны.
 *
 * Отдельная константа от MOBILE_BREAKPOINT намеренно: тот отвечает за
 * превращение сайдбара в Drawer, и планшет в 1000px по нему уже «мобильный»,
 * хотя таблицы на нём читаются. Один порог на два разных вопроса дал бы
 * заглушку там, где интерфейс работает.
 */
export const DESKTOP_MIN_WIDTH = 1024;
